const RestaurantShimmer = () => {
  return (
    <>
      <div className="restoBody">
        <div className="restroShimHeaderCont">
          <div className="restroShimInnerCont">
            <div className="restroShimBox shine"></div>
            <div className="restroLines shine"></div>
            <div className="restroLines shine"></div>
          </div>
        </div>

        <div className="restroShimTCWrapper">
          <div className="restroShimInnerCont">
            <div className="restroShimBox shine"></div>
            <div className="restroLines shine"></div>
            <div className="restroLines shine"></div>
            <div className="restroLines shine"></div>
          </div>
          <div className="restroShimInnerCont">
            <div className="restroShimBox shine"></div>
            <div className="restroLines shine"></div>
            <div className="restroLines shine"></div>
            <div className="restroLines shine"></div>
          </div>
        </div>
        <div className="restroShimOfferCont">
          <div className="restroShimInnerCont">
            <div className="restroShimBox shine"></div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RestaurantShimmer;
